document.addEventListener("DOMContentLoaded", () => {
	// Add listeners for show/hide of video modal

	const videoModal = document.querySelector("#quote-box-video-modal.modal");
	if (!videoModal) return;

	const videoIframe = videoModal.querySelector("iframe");
	const videoId = videoIframe.dataset.videoid;
	console.log(videoId);

	videoModal.addEventListener("show.bs.modal", () => {
		videoIframe.setAttribute("src", `https://www.youtube.com/embed/${videoId}`);
	});

	videoModal.addEventListener("hide.bs.modal", () => {
		videoIframe.setAttribute("src", "");
	});
});
